import { render } from "./TelegramIcon.vue?vue&type=template&id=7f9acfd0"
const script = {}
script.render = render

export default script